// extracted by mini-css-extract-plugin
export default {"recruitment_end_container":"RecruitmentEnd_recruitment_end_container__vi1Lq"};